import SchedulingSection from "@/app/components/AgendamentoComponents/SchedulingSection";
import StepByStepSection from "@/app/components/AgendamentoComponents/StepByStepSection";
import ExampleSection from "@/app/components/AgendamentoComponents/ExampleSection";
import { withServicesLayout } from "@/pages/_layoutService";

function Agendamento() {
  return (
    <div className="flex w-full m-auto flex-col ">
      <SchedulingSection />
      <StepByStepSection />
      <ExampleSection />
    </div>
  );
}
export default withServicesLayout(Agendamento);
export { getServerSideProps } from "@/pages/_layoutService";
